import { Injectable } from '@angular/core';
import { OdooMasterService } from '@app-core/odoo/odoo-master.service';
import { Observable, of, switchMap, } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends OdooMasterService {


  getAllProducts(payload: {}): Observable<any> {
    return this.sendRequest('/api/app/products/get/by/filters', payload , 'post').pipe(
      switchMap((response: any) => {
        return of(response);
      })
    );
  }

  getSearchProducts(payload: {}): Observable<any> {
    return this.sendRequest('/api/app/products/get/by/search', payload , 'post').pipe(
      switchMap((response: any) => {
        return of(response);
      })
    );
  }

  getDetails(product_id: number): Observable<any> {
    return this.sendRequest(`/api/app/products/get/product/detail/${product_id}`, {}, 'get').pipe(
      switchMap((response: any) => {
        return of(response);
      })
    );
  }

  getNavMenu(params: {}): Observable<any> {
    return this.sendRequest('/api/app/products/category-brand/get', { params }, 'get').pipe(
      switchMap((response: any) => {
        return of(response);
      })
    );
  }
}